// src/pages/account/ChangePassword.tsx
import AdminLayout from "@/layouts/AdminLayout";
import Breadcrumbs from "@/components/shared/nav/Breadcrumbs";
import ChangePasswordForm from "@/components/auth/components/ChangePasswordForm";
import { useChangePassword } from "./useChangePassword";

export default function ChangePassword() {
  const { handleSubmit, submitting, redirectSeconds } = useChangePassword();

  return (
    <AdminLayout>
      {/* Header */}
      <div className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900">
          Change password
        </h1>
        <div className="mt-1">
          <Breadcrumbs />
        </div>
      </div>

      {/* Centered container */}
      <div className="max-w-md mx-auto">
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
          <div className="px-6 py-6">
            <ChangePasswordForm onSubmit={handleSubmit} submitting={submitting} />
          </div>
        </div>
      </div>

      {/* Global freeze overlay while submitting */}
      {submitting && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-white/70 backdrop-blur-sm">
          <div className="rounded-xl bg-white px-6 py-4 shadow-lg border border-gray-200 text-center">
            <p className="text-sm font-medium text-gray-800">
              Password updated successfully.
            </p>
            {redirectSeconds !== null && (
              <p className="mt-1 text-xs text-gray-600">
                Redirecting to login in{" "}
                <span className="font-semibold">{redirectSeconds}</span>s…
              </p>
            )}
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
